import { handleResponseOld, makeGet } from './helpers';

/**
 * @category Variant Test API
 * @see fetchUserVariantsBySessionId
 */
type FetchUserVariantsBySessionIdParams = {
    authToken: string;
    deployment: string;
    userSessionId: string;
};
/**
 * fetches a user variant for userSessionId via Get to Variant Test API
 * @function fetchUserVariantsBySessionId
 * @category Variant Test API
 * @param {FetchUserVariantsBySessionId}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/variant-test/gettestvariants
 * @see https://console.aws.amazon.com/apigateway/home?region=us-east-1#/apis/s0ict8v5e8/resources/xkrtyc/methods/GET
 * @see https://github.com/LIVEauctioneers/variant-test-api/tree/master/functions/GetTestVariants
 */
export const fetchUserVariantsBySessionId = ({
    authToken,
    deployment,
    userSessionId,
}: FetchUserVariantsBySessionIdParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makeGet({ authToken, deployment, path: '<VARIANT-TEST-API>gettestvariants' });
        request.send({ userSessionId });
        request.query({ userSessionId });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
